import { Dialog as DialogPrimitive } from '@base-ui/react/dialog';
import { cn } from '@/shared/lib';
import type { DialogProps, DialogTriggerProps } from '@/shared/ui/dialog/types';
import { dialogStyles } from '@/shared/ui/dialog/styles';

/**
 * Root of the dialog surface. Renders no element of its own — Base UI supplies
 * the modal, focus-trap and focus-restore behaviour from here.
 */
export function Dialog({ children, modal = true, ...rest }: DialogProps) {
  return (
    <DialogPrimitive.Root modal={modal} {...rest}>
      {children}
    </DialogPrimitive.Root>
  );
}

/**
 * The control that opens the dialog. It is the element focus returns to when
 * the dialog closes, which is why it must be a real focusable control rather
 * than a click handler bolted onto a wrapper.
 */
export function DialogTrigger({ className, type = 'button', ...props }: DialogTriggerProps) {
  return (
    <DialogPrimitive.Trigger className={cn(dialogStyles.trigger, className)} type={type} {...props} />
  );
}